import { I18n } from '@/services/i18n';

type Message = {
  messageFrom: string;
  giftFrom: string;
  photoFrom: string;
  iHaveSentGift: string;
  iHaveSentPhoto: string;
  reply: string;
  premiumContent: string;
};

const messages: I18n<Message> = {
  en: {
    messageFrom: 'Message from',
    giftFrom: 'Gift from',
    photoFrom: 'Photo from',
    iHaveSentGift: 'I’ve sent a gift to you. Please, check it.',
    iHaveSentPhoto: 'I’ve sent a photo to you. Please, check it.',
    reply: 'Reply',
    premiumContent: 'Premium content',
  },
  es: {
    messageFrom: 'Mensaje de',
    giftFrom: 'Regalo de',
    photoFrom: 'Foto de',
    iHaveSentGift: 'Te he enviado un regalo. Por favor, revísalo.',
    iHaveSentPhoto: 'Te he enviado una foto. Por favor, revísala.',
    reply: 'Responder',
    premiumContent: 'Contenido premium',
  },
  de: {
    messageFrom: 'Nachricht von',
    giftFrom: 'Geschenk von',
    photoFrom: 'Foto von',
    iHaveSentGift: 'Ich habe Ihnen ein Geschenk geschickt. Bitte überprüfen Sie es.',
    iHaveSentPhoto: 'Ich habe Ihnen ein Foto geschickt. Bitte überprüfen Sie es.',
    reply: 'Antworten',
    premiumContent: 'Premium-Inhalt',
  },
};

export { messages };
